(() => {
  const selector = 'a[href], .js-open-quiz-popup, #meuQuizPopup';
  const blocked = (element) => {
    if (element.matches('.js-open-quiz-popup, #meuQuizPopup')) return true;
    try { return /\/pages\/[^/]*quiz[^/]*(?:\/|$)/i.test(new URL(element.getAttribute('href'), location.href).pathname); }
    catch { return false; }
  };
  const removeAccess = (root) => {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches?.(selector) && blocked(root)) { root.remove(); return; }
    root.querySelectorAll(selector).forEach((element) => { if (blocked(element)) element.remove(); });
  };
  removeAccess(document);
  new MutationObserver((records) => records.forEach((record) => {
    if (record.type === 'attributes') removeAccess(record.target);
    else record.addedNodes.forEach(removeAccess);
  })).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['href', 'class'] });
  document.addEventListener('click', (event) => {
    const target = event.target.closest?.(selector);
    if (target && blocked(target)) { event.preventDefault(); event.stopImmediatePropagation(); target.remove(); }
  }, true);
})();
